import _classCallCheck from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import './image_click.less';
import { Dom, CommonCaptcha, move, initConfig, destroyEvent } from '../common/common.js';

/**
 * 滑动验证码
 */

var TYPE = 'IMAGE_CLICK';
function getTemplate(styleConfig) {
  return "\n<div id=\"tianai-captcha\" class=\"tianai-captcha-slider tianai-captcha-word-click\">\n    <div class=\"click-tip\">\n        <span id=\"tianai-captcha-click-track-font\" style=\"font-size: ".concat(styleConfig.i18n.image_click_title_size, "\">").concat(styleConfig.i18n.image_click_title, "</span>\n        <img src=\"\" id=\"tianai-captcha-tip-img\" class=\"tip-img\">\n    </div>\n    <div class=\"content\">\n        <div class=\"bg-img-div\">\n            <img id=\"tianai-captcha-slider-bg-img\" src=\"\" alt/>\n            <canvas id=\"tianai-captcha-slider-bg-canvas\"></canvas>\n            <div id=\"bg-img-click-mask\"></div>\n        </div>\n         <div class=\"tianai-captcha-tips\" id=\"tianai-captcha-tips\"></div>\n    </div>\n    <div class=\"click-confirm-btn\">\u786E\u5B9A</div>\n</div>\n");
}
var ImageClick = /*#__PURE__*/function (_CommonCaptcha) {
  function ImageClick(boxEl, styleConfig) {
    var _this;
    _classCallCheck(this, ImageClick);
    _this = _callSuper(this, ImageClick);
    _this.boxEl = boxEl;
    _this.styleConfig = styleConfig;
    _this.type = TYPE;
    _this.currentCaptchaData = {};
    return _this;
  }
  _inherits(ImageClick, _CommonCaptcha);
  return _createClass(ImageClick, [{
    key: "init",
    value: function init(captchaData, endCallback, loadSuccessCallback) {
      var _this2 = this;
      // 重载样式
      this.destroy();
      this.boxEl.append(getTemplate(this.styleConfig));
      this.el = this.boxEl.find('#tianai-captcha');
      // 绑定全局
      // window.currentCaptcha = this;
      // 载入验证码
      this.loadCaptchaForData(this, captchaData);
      this.endCallback = endCallback;
      var moveFun = move.bind(null, this);
      // 绑定事件
      this.el.find('#bg-img-click-mask').click(function (event) {
        if (event.target.className === 'click-span') {
          return;
        }
        _this2.currentCaptchaData.clickCount++;
        var trackList = _this2.currentCaptchaData.trackList;
        if (_this2.currentCaptchaData.clickCount === 1) {
          _this2.currentCaptchaData.startTime = new Date();
          // move 轨迹
          window.addEventListener('mousemove', moveFun);
          _this2.currentCaptchaData.startX = event.offsetX;
          _this2.currentCaptchaData.startY = event.offsetY;
        }
        var startTime = _this2.currentCaptchaData.startTime;
        trackList.push({
          x: Math.round(event.offsetX),
          y: Math.round(event.offsetY),
          type: 'click',
          t: new Date().getTime() - startTime.getTime()
        });
        var left = event.offsetX - 10;
        var top = event.offsetY - 10;
        _this2.el.find('#bg-img-click-mask').append("<span class='click-span' style='left:" + left + 'px;top: ' + top + "px'>" + _this2.currentCaptchaData.clickCount + '</span>');
        // if (this.currentCaptchaData.clickCount === 4) {
        //     // 校验
        //     this.currentCaptchaData.stopTime = new Date();
        //     window.removeEventListener("mousemove", move);
        //     this.endCallback(this.currentCaptchaData,this);
        // }
      });
      this.el.find('.click-confirm-btn').click(function () {
        if (_this2.currentCaptchaData.clickCount > 0) {
          // 校验
          _this2.currentCaptchaData.stopTime = new Date();
          window.removeEventListener('mousemove', moveFun);
          _this2.endCallback(_this2.currentCaptchaData, _this2);
        }
      });
      if (loadSuccessCallback) {
        // 加载成功
        loadSuccessCallback(this);
      }
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var existsCaptchaEl = this.boxEl.children('#tianai-captcha');
      if (existsCaptchaEl) {
        existsCaptchaEl.remove();
      }
      destroyEvent();
    }
  }, {
    key: "loadCaptchaForData",
    value: function loadCaptchaForData(that, data) {
      var bgImg = that.el.find('#tianai-captcha-slider-bg-img');
      var tipImg = that.el.find('#tianai-captcha-tip-img');
      bgImg.on('load', function () {
        that.currentCaptchaData = initConfig(bgImg.width(), bgImg.height(), tipImg.width(), tipImg.height());
        that.currentCaptchaData.currentCaptchaId = data.id;
      });
      bgImg.attr('src', data.captcha.backgroundImage);
      tipImg.attr('src', data.captcha.templateImage);
    }
  }]);
}(CommonCaptcha);
export default ImageClick;